module.exports = __webpack_public_path__ + "2a096541cd32eef7854fdfebb813aecd.svg";